// extracted by mini-css-extract-plugin
module.exports = {"PasswordRequirements":"PasswordRequirements_PasswordRequirements__35ATC"};